var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-nav-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showAnchor),expression:"showAnchor"}],staticClass:"anchor-navigation-li",attrs:{"href":'#' + _vm.contentId},on:{"click":_vm.passClick}},[_vm._t("anchor-header")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }